import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=3d583cf4&scoped=true"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupInfo.vue?vue&type=style&index=0&id=3d583cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d583cf4",
  null
  
)

export default component.exports